// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TextTileFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import TileTitleFrontSide from '../Izenda.TileTitleFrontSide';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import PrintingUtils from 'share/utils/Izenda.PrintingUtils';

@observer
class TextTileFrontSide extends Component {
  static displayName = "TextTileFrontSide";

  static propTypes = {
    dashboardPart: PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {
      textTitleHeight: 0
    };

    this.renderListeners = [];
    this.tileTitleFrontSideKey = 'TileTitleFrontSide';
    PrintingUtils.pushRenderListener(this.renderListeners, this.tileTitleFrontSideKey);
  }

  publishFinishedRender = () => {
    const props = this.props;
    props.printingMode &&
      PrintingUtils.publishFinishedRender(this.renderListeners, () => {
        props.finishedRender && props.finishedRender();
      });
  };

  componentDidMount() {
    this.publishFinishedRender();
  }

  componentDidUpdate() {
    this.publishFinishedRender();
  }

  render() {
    const { dashboardPart, printingMode, cellWidth, fulfilledData } = this.props;
    const htmlText = dashboardPart.getBodyText();
    const bodyConfig = dashboardPart.getBodyConfig();
    const renderListeners = this.renderListeners;

    if (printingMode) {
      const style = dashboardPart.getContainerSize(cellWidth);
      return (
        <div className="u_paddingTop u_paddingBottom" style={style}>
          <div className="u_paddingLeft u_paddingRight u_fullSize">
            <TileTitleFrontSide
              dashboardPart={dashboardPart}
              finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, this.tileTitleFrontSideKey)}
              fulfilledData={fulfilledData}
              printingMode={printingMode}
            />
            <div className="u_table u_fullSize">
              <div className="u_tableCell" style={getBodyStyle()} dangerouslySetInnerHTML={{ __html: htmlText }} />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="u_paddingTop u_paddingBottom u_fullSize">
        <ScrollBox viewClassName="u_paddingLeft u_paddingRight">
          <div>
            <TileTitleFrontSide {...this.props} />
            <div className="u_table u_fullSize">
              <div className="u_tableCell" style={getBodyStyle()} dangerouslySetInnerHTML={{ __html: htmlText }} />
            </div>
          </div>
        </ScrollBox>
      </div>
    );

    /**
         * Get vertical align style for body text
         */
    function getBodyStyle() {
      const verticalAlign = classnames({
        top: bodyConfig.alignTop,
        middle: bodyConfig.alignMiddle,
        bottom: bodyConfig.alignBottom
      });
      return {
        verticalAlign: verticalAlign
      };
    }
  }
}
export default TextTileFrontSide;



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/TextTile/Izenda.TextTileFrontSide.js